import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../QuizHub/QuizHub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import hh from "../../images/hub-img.webp";
import cc from "../../images/hub-card.webp";
import gg from "../../images/gift-green.svg";
import axios from "axios";
import ff from "../../images/pp-logo.gif";
import { END_URL, IMG_URL } from "../../config";
import { slugify } from '../../utils/slugify';
import arr from "../../images/downarr.svg"

function HubTopicDetail({slug,token,onsignup,onLoginChange,userdetail}) {

    const [hubTopic, sethubTopic] = useState(null);

    const [loading, setLoading] = useState(true);

    const [openIndex, setOpenIndex] = useState(0);

    const [CarrerModal, setCarrerModal] = useState(false);
    const [careerContent, setCareerContent] = useState("");

    useEffect(() => {
        fetchHub();
    }, [slug]);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


    const fetchHub = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${END_URL}/hub-topic-details/${slug}`
            );

            sethubTopic(response.data.hub_topic_detail);
  
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {

        return (

                <div className="loadingDiv" >
                
                    <img src={ff}  alt="Loading..." />
        
                </div>
        );
    }

   
  return (
    <>
    <div className="hub-main hub-topic-detail">
      <div className="ques-main hub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">
              <div className="ques-top" style={{'--banner_image': `url(${IMG_URL}/d0/${hubTopic?.topic_banner_image})`}}>
          
                <div className="ques-top-title">
                
                  <div className="quiz-banner-content" dangerouslySetInnerHTML={{__html:hubTopic?.topic_banner_content}}/>

                  <div className="hub-banner-bnts">

                    {hubTopic?.topic_banner_btn_1 && hubTopic?.topic_banner_btn_link_1 && (
                      <a href={`/${hubTopic?.topic_banner_btn_link_1}`} class="new-commom-btn homearche-explore">

                        <span>{hubTopic?.topic_banner_btn_1}</span>

                        <span class="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    )}

                    {hubTopic?.topic_banner_btn_link_2 && hubTopic?.topic_banner_btn_2 && (

                      <a href={`/${hubTopic?.topic_banner_btn_link_2}`} class="new-commom-btn hub-banner-reveal">

                        <span>{hubTopic?.topic_banner_btn_2}</span>

                        <span class="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>

                    )}

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hub-section">

        <div className="container">

            <div className="row hub-pattern-card-row">

                <div className="hub-pattern-card-outer">

                    {hubTopic?.cards.map((card, index) => (
                        <div className="hub-pattern-cards" key={index}>
                            <div>
                            <img
                                src={`${IMG_URL}/d0/${card.hub_topic_card_image}`}
                                alt=""
                            />
                            </div>

                            <div className="hub-pattern-cards-content">
                            <div
                                className="hub-carrer-content"
                                dangerouslySetInnerHTML={{
                                __html: card.hub_topic_card_content,
                                }}
                            />

                            {card.hub_topic_card_button_1 && card.hub_topic_card_button_link_1 && (

                                <a href={`/${card.hub_topic_card_button_link_1}`} className="new-commom-btn hub-banner-reveal"   >
                                
                                    <span>{card.hub_topic_card_button_link_1}</span>

                                    <span className="righ-arr">
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>
                            )}
                            </div>
                        </div>
                    ))}

                </div>

                <div className="quizhub-unique">

                    <div className="container">

                        <div className="choosen-title">

                            <h2> {hubTopic?.choose_question_title}</h2>

                        </div>

                        <div className="row quizhub-unique-outer-row">
            
                        {hubTopic?.choose_title_1 && (
            
                            <div className="col-md-3">
                                <div className="quizhub-unibox">
                                    <span>
                                        <img src={`${IMG_URL}/d0/${hubTopic?.choose_icon_1}`} alt="" />
                                    </span>
            
                                    <h2>how do i grow </h2>
                                
                                </div>
                            </div>
                        )}
            
                        {hubTopic?.choose_title_2 && (
            
                            <div className="col-md-3">
                                <div className="quizhub-unibox">
                                    <span>
                                        <img src={`${IMG_URL}/d0/${hubTopic?.choose_icon_2}`} alt="" />
                                    </span>
            
                                    <h2>how do i grow </h2>
                                    
                                </div>
                            </div>
                        )}
            
                        {hubTopic?.choose_title_3 && (
            
                            <div className="col-md-3">
                                <div className="quizhub-unibox">
                                    <span>
                                        <img src={`${IMG_URL}/d0/${hubTopic?.choose_icon_3}`} alt="" />
                                    </span>
            
                                    <h2>how do i grow </h2>
                                    
                                </div>
                            </div>
                        )}
            
                        {hubTopic?.choose_title_4 && (
        
                        <div className="col-md-3">
                                <div className="quizhub-unibox">
                                    <span>
                                    <img src={`${IMG_URL}/d0/${hubTopic?.choose_icon_4}`} alt="" />
                                    </span>
        
                                    <h2>how do i grow </h2>
                                
                                </div>
                            </div>
                        )}

                        {hubTopic?.choose_title_5 && (
        
                            <div className="col-md-3">
                                    <div className="quizhub-unibox">
                                        <span>
                                        <img src={`${IMG_URL}/d0/${hubTopic?.choose_icon_5}`} alt="" />
                                        </span>
            
                                        <h2>how do i grow </h2>
                                    
                                    </div>
                                </div>
                        )}
            
            
                        </div>
                    </div>
                </div>

            </div>

        </div>
      </div>
    </div>

      {CarrerModal && (
        <div className="newdashpop-overlay lock-dashboard carrer-banner">
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                onClick={() => {
                  setCarrerModal(false);
                  setCareerContent("");
                }}
              >
                &times;
              </button>

              <div className="conent-pop lock-dashboard-content">
                <div className="dash-loc-title">

                  <div
                    dangerouslySetInnerHTML={{ __html: careerContent }}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
}

export default HubTopicDetail;
